import { render, staticRenderFns } from "./brokenTaskModal.vue?vue&type=template&id=007c9467&scoped=true&"
import script from "./brokenTaskModal.vue?vue&type=script&lang=js&"
export * from "./brokenTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./brokenTaskModal.vue?vue&type=style&index=0&id=007c9467&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c9467",
  null
  
)

export default component.exports